.biel-input-option-container {
  position: relative;
}

.biel-input-option__button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 8px 12px;
  background-color: var(--biel-bot-content-bg-color);
  color: var(--biel-input-color);
  border: 1px solid var(--biel-input-border-color);
  border-radius: var(--biel-input-border-radius);
  cursor: pointer;
  transition: all 0.2s ease;
}

.biel-input-option__button:hover {
  background-color: var(--biel-input-options-button-hover-bg-color);
  border-color: var(--biel-input-options-button-hover-border-color);
}

.biel-input-option__button:focus {
  outline: none;
  border-color: var(--biel-input-options-button-focus-border-color);
}

.biel-input-option__button-text {
  margin-right: 5px;
}

.biel-input-option__chevron {
  transition: transform 0.2s ease;
  color: var(--biel-input-color);
}

.biel-input-option__chevron.open {
  transform: rotate(180deg);
}

.biel-input-option__dropdown {
  position: absolute;
  bottom: 100%;
  min-width: max-content;
  margin-bottom: 8px;
  border: 1px solid var(--biel-dropdown-border-color);
  border-radius: var(--biel-input-border-radius);
  background-color: var(--biel-dropdown-bg-color);
  z-index: 1000;
  overflow: hidden;
  animation: fadeIn 0.15s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
